import { CurbLinkRecord, defaultCurbLinkRecord } from "./CurbLink";
import { GeometryInterface, defaultGeometryRecord } from "./Geometry";

export interface ProposedLinkRecord extends CurbLinkRecord {
    paren_link_id: number;
    proposed_regulation_id: number;
    geometry: GeometryInterface;
}

export const defaultProposedLinkRecord = {
    ...defaultCurbLinkRecord,
    geometry: defaultGeometryRecord,
    paren_link_id: 0,
    proposed_regulation_id: 0
};
